// import monitoringDevices from "../repositories/modules/monitoring-devices";
import {
  Validator,
} from "./validator";

const ITEM_CODE = {
  EVENT_START_NOTIFICATION_TITLE: "01",
  EVENT_END_NOTIFICATION_TITLE: "02",
};

class ContactMonitoringEventRulesValidator extends Validator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();

    this.errors.eventStartNotificationTitle = [];
    this.errors.eventEndNotificationTitle = [];
  }
  /* eslint-enable */
}

class ContactMonitoringEventRulesStoreValidator extends ContactMonitoringEventRulesValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static validate(contactMonitringEventRule) {
    const validator = new ContactMonitoringEventRulesValidator();

    validator.checkNotificationTitle(
      "eventStartNotificationTitle",
      contactMonitringEventRule.eventStartNotification.title,
      "アラート発生時のメール件名",
      ITEM_CODE.EVENT_START_NOTIFICATION_TITLE,
      {
        required: false,
      },
    );

    validator.checkNotificationTitle(
      "eventEndNotificationTitle",
      contactMonitringEventRule.eventEndNotification.title,
      "復旧時のメール件名",
      ITEM_CODE.EVENT_END_NOTIFICATION_TITLE,
      {
        required: false,
      },
    );

    return validator;
  }
}

class ContactMonitoringEventRulesUpdateValidator extends ContactMonitoringEventRulesValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static validate(contactMonitringEventRule) {
    const validator = new ContactMonitoringEventRulesUpdateValidator();

    validator.checkNotificationTitle(
      "eventStartNotificationTitle",
      contactMonitringEventRule.eventStartNotification.title,
      "アラート発生時のメール件名",
      ITEM_CODE.EVENT_START_NOTIFICATION_TITLE,
      {
        required: false,
      },
    );

    validator.checkNotificationTitle(
      "eventEndNotificationTitle",
      contactMonitringEventRule.eventEndNotificationTitle.title,
      "復旧時のメール件名",
      ITEM_CODE.EVENT_END_NOTIFICATION_TITLE,
      {
        required: false,
      },
    );

    return validator;
  }
}

export {
  ContactMonitoringEventRulesValidator,
  ContactMonitoringEventRulesStoreValidator,
  ContactMonitoringEventRulesUpdateValidator,
};
